module.exports = __webpack_public_path__ + "static/img/5429d7ea9d406328ecd34707e869e981.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro2.jpg
// module id = z9jn
// module chunks = 1